import React, { useState } from 'react';
import './levelcard.css';
import { useSound } from '../../hooks/useSound';

const Levelcard = (props) => {
    const [shake, setShake] = useState(false);
    const earnedStars = props.earnedStars || 0;
    const { playHover, playClick, playLock } = useSound();

    const handleClick = () => {
        if (props.lock === 'lockedlvl') {
            playLock();
            setShake(false);
            setTimeout(() => setShake(true), 10);
            setTimeout(() => setShake(false), 1000);
            return;
        }
        playClick();
        if (props.onClick) {
            props.onClick();
        }
    };

    return (
        <section
            className={props.lock}
            onClick={handleClick}
            onMouseEnter={playHover}
        >
            {props.lock === 'lockedlvl' && (
                <div className={`lock ${shake ? 'lockshake' : ''}`}></div>
            )}

            <h5 className='levelnumber'>{props.number}</h5>
            <h5 className='levelname'>{props.name}</h5>

            <article className='starcont'>
                {[0, 1, 2].map(i => (
                    <div key={i} className={`star ${i < earnedStars ? 'star-earned' : ''}`}></div>
                ))}
            </article>
        </section>
    );
}

export default Levelcard;